<template>
    <div class="container-fluid">
        <Breadcrumb v-bind:title="'Email List #' + id" v-bind:button-show="false">
            <button type="button" class="btn btn-info d-none d-lg-block m-l-15" @click="addEmailList()"
                    v-if="isGranted()">
                <i class="fa fa-plus-circle"></i> Add Emails
            </button>
        </Breadcrumb>
        <div class="row" style="position: relative">
            <div class="col-12 row-preloader">
                <Preloader v-bind:class="{preloader: loading}" v-show="loading"></Preloader>
            </div>
            <div class="col-12" v-show="!loading">
                <div class="card">
                    <div class="card-body">
                        <div v-if="emails.length === 0">There are no Emails in this List</div>
                        <div v-else>
                            <div class="form-group">
                                <input v-model="search" type="text" class="form-control form-control-line"
                                       placeholder="Search email">
                            </div>
                            <div v-if="filteredEmails.length > 0">
                                <div class="table-responsive">
                                    <table class="table" id="emailsListTable">
                                        <thead>
                                        <tr>
                                            <th v-if="isGranted()"><input type="checkbox" @click="toggleCheck()"
                                                                        ref="toggleCheck"/></th>
                                            <th>ID</th>
                                            <th>Email</th>
                                            <th>Name</th>
                                            <th>Surname</th>
                                            <th>Valid</th>
                                            <th v-if="isGranted()">Actions</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(email, index) in filteredEmails" :key="index">
                                                <td v-if="isGranted()"><input type="checkbox" class="checkEmail" :id="email.id"
                                                                            v-bind:value="email.id"/></td>
                                                <td>{{email.id}}</td>
                                                <td>{{email.email}}</td>
                                                <td>{{email.first_name}}</td>
                                                <td>{{email.last_name}}</td>
                                                <td>{{email.valid}}</td>
                                                <td v-if="isGranted()">
                                                    <button type="button" class="btn btn-danger" @click="deleteEmail(email.id)">
                                                        <i class="fa fa-minus-circle"></i> Delete
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div v-if="isGranted()">
                                    <button type="button" class="btn btn-danger" @click="batchDeleteEmail">
                                        <i class="fa fa-minus-circle"></i> Delete
                                    </button>
                                </div>
                                <paginate v-if="pageCount > 1"
                                          v-model="page"
                                          :page-count="pageCount"
                                          :page-range="3"
                                          :margin-pages="2"
                                          :click-handler="getItems"
                                          :prev-text="'Prev'"
                                          :next-text="'Next'"
                                          :container-class="'pagination justify-content-center'"
                                          :page-class="'page-item'"
                                          :page-link-class="'page-link'"
                                          :prev-class="'page-item'"
                                          :prev-link-class="'page-link'"
                                          :next-class="'page-item'"
                                          :next-link-class="'page-link'">
                                </paginate>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Swal from 'sweetalert2';
    import EmailService from '../services/EmailService';
    import Preloader from '../components/Preloader';
    import Breadcrumb from '../components/Breadcrumb';
    import paginateMixin from '../mixins/paginate-mixin';

    export default {
        name: 'Emails',
        props: ['id'],
        components: {
            Breadcrumb,
            Preloader
        },
        mixins: [ paginateMixin ],
        data() {
            return {
                search: '',
                emails: [],
                emailListUsername: '',
                totalItems: 0,
                page: 1,
                perPage: 10,
                loading: false,
                username: '',
                isAdmin: false
            }
        },
        mounted() {
            this.getItems();
            this.username = localStorage.getItem('username');
            this.isAdmin = this.$store.getters.isAdmin;
        },
        methods: {
            addEmailList() {
                Swal({
                    title: 'Add Emails to List',
                    html: '<input type="file" id="emails" accept="text/csv" />',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        let emails = document.getElementById('emails').files[0];

                        let formData = new FormData();

                        formData.append('emailListId', this.id);
                        formData.append('emails', emails);
                        formData.append('context', 'emailsList');

                        return EmailService.addEmailsToList(formData).then(response => {
                            if (response.data.error) {
                                let message = null;
                                if (response.data.error.emails) {
                                    message = response.data.error.emails;
                                }

                                if (response.data.error.emailListId) {
                                    message = response.data.error.emailListId;
                                }

                                Swal.showValidationMessage(
                                    `Request failed: ${message}`
                                );

                                return false;
                            }
                        }).catch(error => {
                            Swal.showValidationMessage(
                                `Request failed: ${error}`
                            )
                        });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value) {
                        Swal(
                            'Added successfully!',
                            `We will notify you, when moderation process will be done.`,
                            'success'
                        )
                    }
                })
            },
            deleteEmail(id) {
                Swal({
                    title: 'Are you sure you want to delete?',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        let formData = new FormData();
                        formData.append('emailListId', this.id);

                        return EmailService.deleteEmail(id, formData).then((response) => {
                            if (response.status === 204) {
                                let emailIndex = this.emails.findIndex(obj => obj.id === id);
                                this.emails.splice(emailIndex, 1);
                            }
                            if (response.status === 500) {
                                Swal.showValidationMessage(
                                    `Delete failed: ${response.data.error}`
                                );
                                return false;
                            }
                        }).catch(error => {
                            Swal.showValidationMessage(
                                `Request failed: ${error}`
                            )
                        });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value) {
                        Swal(
                            'Deleted successfully!',
                            `Email has been deleted.`,
                            'success'
                        )
                    }
                })
            },
            batchDeleteEmail() {
                let idsToDelete = [];

                let selectedCheckboxes = document.querySelectorAll("input.checkEmail[type='checkbox']:checked");

                selectedCheckboxes.forEach(function (item) {
                    idsToDelete.push(item.value);
                });

                if (idsToDelete.length === 0) {
                    Swal({
                        title: 'You must select something to delete',
                        inputAttributes: {
                            autocapitalize: 'off'
                        },
                        showCancelButton: true,
                        confirmButtonText: 'Ok',
                    });

                    return false;
                }

                Swal({
                    title: 'Are you sure you want to delete?',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        let formData = new FormData();
                        formData.append('idsToDelete', idsToDelete);
                        formData.append('emailListId', this.id);

                        return EmailService.batchDeleteEmail(formData).then(() => {
                            for (let i = 0; i < idsToDelete.length; i++) {
                                let emailIndex = this.emails.findIndex(obj => obj.id === idsToDelete[i]);
                                this.emails.splice(emailIndex, 1);
                            }
                            this.uncheckAll();
                        }).catch(error => {
                            Swal.showValidationMessage(
                                `Request failed: ${error}`
                            )
                        });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value) {
                        Swal(
                            'Deleted successfully!',
                            `Emails have been deleted.`,
                            'success'
                        )
                    }
                })
            },
            toggleCheck() {
                if (this.$refs.toggleCheck.checked) {
                    this.checkAll();
                } else {
                    this.uncheckAll();
                }
            },
            uncheckAll() {
                document.querySelectorAll("input[type='checkbox']").forEach(checkbox => checkbox.checked = false);
            },
            checkAll() {
                document.querySelectorAll("input[type='checkbox']").forEach(checkbox => checkbox.checked = true);
            },
            getItems: function () {
                this.loading = true;
                EmailService.getEmailList(this.id, this.page, this.perPage).then(response => {
                    this.emails = response.data.items;
                    this.totalItems = response.data.totalItems;
                    this.emailListUsername = response.data.emailListUsername;
                    this.loading = false;
                });
            },
            isGranted() {
                return this.username === this.emailListUsername || this.isAdmin
            }
        },
        computed: {
            filteredEmails: function () {
                return this.emails.filter((item) => {
                    if (this.search === null || this.search === undefined) return true;
                    return item.email.includes(this.search)
                })
            },
            pageCount: function () {
                return Math.ceil(this.totalItems / this.perPage);
            }
        }
    }
</script>

<style scoped>

</style>